"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _topAreaBannerContext = require("./topAreaBannerContext");
Object.keys(_topAreaBannerContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _topAreaBannerContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _topAreaBannerContext[key];
    }
  });
});